import React from "react";
import {
  Container,
  Grid,
  Paper,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";
import dat from "./data.json";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import requestOAI from "./openai.js";
import { useEffect } from "react";
import predictReplicate from "./replicate.js";
import interval from "./setting.js";
import interval_print from "./setting.js";

function HomePage() {
  let _content;
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  let [data, setData] = React.useState(dat);
  let num = 0;

  const delay = async (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  let messages = [
    {
      role: "system",
      content:
        "You are a journalist, your role is to generate a news article imitating The New York Times style, describing absurd, abstract, and novel stories set in a futuristic background. Ensure the stories have a negative twist, involving protagonists who have done something bad. The length of each news article should be similar to a standard newspaper article. You should generate a headline, a short paragraph of content, and the description of the image. Please provide the content in JSON format for easy use. Formatting should strictly follow: { 'Headline': ...; 'Content': ...; 'Image Description': ...; } in json format",
    },
  ];

  async function sendMessage(mes) {
    console.log(`Waiting for ${interval / 1000} seconds`);
    await delay(interval);
    console.log("Waiting Ends");
    console.log("Starting generate report");
    // get the text from the text field
    let content = mes;

    // don't send empty messages to the API
    if (content == "") {
      return;
    }

    // add the text to the array of messages
    messages.push({
      role: "user", // this comes from the user
      content: mes,
    });

    // send the request
    let params = {
      model: "gpt-3.5-turbo",
      messages: messages,
      temperature: 0.7,
    };
    requestOAI("POST", "/v1/chat/completions", params, gotResults);

    // Note: there are additional parameters available, see
    // https://platform.openai.com/docs/api-reference/chat
  }

  function gotResults(results) {
    // add the first response-choice to the messages array
    messages.push(results.choices[0].message);

    let t = JSON.parse(results.choices[0].message.content);
    console.log(t);
    _content = t;
    if (data[num]["pic"]) {
      let modelInput = {
        prompt: _content["Image Description"] + "in realistic style",
        scheduler: "K_EULER",
      };

      predictReplicate(
        "stability-ai/stable-diffusion:ac732df83cea7fff18b8472768c88ad041fa750ff7682a21affe81863cbe77e4",
        modelInput,
        donePredicting
      );
      console.log("Starting prediction, this might take a bit");
    } else {
      setData((prevData) => {
        // Create a new array to avoid direct mutation
        const newData = [...prevData];
        console.log(num);
        newData[num] = {
          title: _content["Headline"],
          content: _content["Content"],
        };
        console.log(newData);
        num >= 5 ? (num = 0) : num++;
        if (num === 0) {
          window.print();
        }
        return newData;
      });
      sendMessage("Please generate a report");
    }
  }

  function donePredicting(results) {
    console.log(results);

    setData((prevData) => {
      // Create a new array to avoid direct mutation
      const newData = [...prevData];
      console.log(num);
      newData[num] = {
        title: _content["Headline"],
        content: _content["Content"],
        pic: results[0],
      };
      console.log(newData);
      num >= 5 ? (num = 0) : num++;
      if (num === 0) {
        window.print();
      }
      return newData;
    });

    sendMessage("Please generate a report");
  }

  useEffect(() => {
    let isMounted = true; // To prevent memory leaks in case the component unmounts

    sendMessage("Please generate a report");

    // Cleanup function to stop the loop when the component unmounts
    return () => {
      isMounted = false;
    };
  }, []); // Empty dependency array to run only once

  const currentDate = new Date();

  // Add 10 years to the current date
  currentDate.setFullYear(currentDate.getFullYear() + 10);

  const formattedDate = currentDate
    .toLocaleDateString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    .toUpperCase();

  return (
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12}></Grid>

        {/* Title */}
        <Grid item xs={12}>
          <Typography
            variant={isMdUp ? "h1" : "h5"}
            align="center"
            fontWeight="bold"
          >
            NEOHARMONY NEWS
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              borderBottom: "3px solid black",
              borderTop: "3px solid black",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                alignContent: "center",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                marginTop: "4px",
                marginBottom: "4px",
                width: "100%",
                height: "50px",
              }}
            >
              <Typography
                variant="subtitle1"
                justifyContent={"center"}
                alignContent={"center"}
              >
                ISSUE #36
              </Typography>
              <Typography
                variant="subtitle1"
                justifyContent={"center"}
                alignContent={"center"}
              >
                {formattedDate}
              </Typography>
              <Typography
                variant="subtitle1"
                justifyContent={"center"}
                alignContent={"center"}
              >
                SPECIAL EDITION
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Body */}
        <Grid item xs={12} md={8} container>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{ textAlign: "left" }}
              gutterBottom
            >
              {data[0]["title"]}
            </Typography>
            <Box display="flex" flexDirection="row">
              <Box display="flex" flex={1} marginRight={4}>
                <Typography variant="body1" paragraph>
                  {data[0]["content"]}
                </Typography>
              </Box>
              <Box display="flex" flex={1} position="relative">
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "100%", // This maintains the square aspect ratio
                    backgroundColor: "rgb(100, 100, 100)",
                  }}
                >
                  <img
                    src={data[0]["pic"]}
                    alt="news"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ensures the image covers the container while maintaining its aspect ratio
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} container spacing={4} marginTop={2}>
            <Grid item xs={12} md={6}>
              <Box display="flex" flexDirection="column">
                <Box display="flex" width={"100%"}>
                  <img src={data[1]["pic"]} width={"100%"} alt="news" />
                </Box>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ textAlign: "left" }}
                  marginTop={2}
                  gutterBottom
                >
                  {data[1]["title"]}
                </Typography>
                <Box display="flex" flexDirection="row">
                  <Box display="flex" flex={1}>
                    <Typography variant="body1" paragraph>
                      {data[1]["content"]}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                height={"100%"}
                justifyContent={"space-evenly"}
                borderTop={"1px solid black"}
              >
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ textAlign: "left" }}
                    gutterBottom
                  >
                    {data[2]["title"]}
                  </Typography>

                  <Typography variant="body1" paragraph>
                    {data[2]["content"]}
                  </Typography>
                </Box>
                <Box borderTop={"1px solid black"}></Box>
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ textAlign: "left" }}
                    gutterBottom
                  >
                    {data[3]["title"]}
                  </Typography>

                  <Typography variant="body1" paragraph>
                    {data[3]["content"]}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            borderLeft={isMdUp ? "1px solid black" : "none"}
            paddingLeft={isMdUp ? "32px" : "0"}
            display={"flex"}
            flexDirection={"column"}
            height={"100%"}
          >
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Hot this month
            </Typography>

            <img src={data[4]["pic"]} width={"100%"} alt="news" />
            <Box display={"flex"} width={"100%"} bgcolor={"rgb(200,200,200)"}>
              <Typography variant="body1" margin={"4px"}>
                BREAKING NEWS
              </Typography>
            </Box>
            <Box bgcolor={"rgb(200,200,200)"}>
              <Typography
                variant="h6"
                margin={"8px"}
                fontWeight="bold"
                gutterBottom
                sx={{ textAlign: "left" }}
              >
                {data[4]["title"]}
              </Typography>
              <Typography variant="body2" margin={"8px"} paragraph>
                {data[4]["content"]}
              </Typography>
            </Box>
            <Box marginTop={4}>
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                sx={{ textAlign: "left" }}
              >
                {data[5]["title"]}
              </Typography>

              <Typography variant="body1" paragraph>
                {data[5]["content"]}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default HomePage;
